var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-profile pull-right"},[_vm._t("default",function(){return [_c('img',{attrs:{"src":_vm.src,"alt":""}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }